import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    TextField,
    InputAdornment,
    IconButton,
    Tooltip,
    Box
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import {OP_BUTTON_STYLE} from "@/constants/styles";
import {SendIcon} from "lucide-react";

interface TelegramInviteDialogProps {
    open: boolean;
    onClose: () => void;
    inviteLink: string;
}

export const TelegramInviteDialog: React.FC<TelegramInviteDialogProps> = ({
                                                                              open,
                                                                              onClose,
                                                                              inviteLink,
                                                                          }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(inviteLink);
            setCopied(true);
            // Ripristina lo stato del tooltip dopo 2 secondi
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ m: 0, p: 2, pr: 6 }}>
                Join Our Telegram Channel
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <DialogContentText sx={{ mb: 2 }}>
                    Use the link below to join our bot and stay updated on content created by the platform.
                </DialogContentText>

                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        value={inviteLink}
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'} arrow>
                                        <IconButton onClick={handleCopy} edge="end" color={copied ? 'success' : 'primary'}>
                                            <ContentCopyIcon />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant={"contained"} sx={OP_BUTTON_STYLE} startIcon={<CloseIcon />}>
                    Close
                </Button>
                <Button
                    href={inviteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    color="primary"
                    startIcon={<SendIcon/>}
                >
                    Open Telegram
                </Button>
            </DialogActions>
        </Dialog>
    );
};